import "./src/pages/pages.css";
import "./src/layouts/index.css";
import "react-image-gallery/styles/image-gallery.css";
import { captureAttribution } from "./src/utils/attribution";
import { trackBookCallClick } from "./src/utils/analytics";

const BOOK_CALL_ZCAL_PATH = "/i/c9mEbhSA";

const trackZcalLinkClick = (event) => {
  const link = event.target.closest?.("a[href]");
  if (!link) return;

  try {
    const url = new URL(link.href);
    const hostname = url.hostname.toLowerCase();
    const pathname = url.pathname.replace(/\/$/, "");
    const isZcal = hostname === "zcal.co" || hostname.endsWith(".zcal.co");

    if (isZcal && pathname === BOOK_CALL_ZCAL_PATH) {
      trackBookCallClick();
    }
  } catch {
    // Ignore malformed URLs and let the browser handle the click normally.
  }
};

export const onClientEntry = () => {
  captureAttribution();
  document.addEventListener("click", trackZcalLinkClick);
};

export const onRouteUpdate = () => {
  captureAttribution();
};
